// extracted by mini-css-extract-plugin
export default {"portfolioHead":"Portfolio_portfolioHead__6DPfA","slide":"Portfolio_slide__CQ-o6","portfolio":"Portfolio_portfolio__aK3KA"};